import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { PriceDisplay } from './PriceDisplay';
const CART_URL = 'https://mujeresempoderadas.lat/cart/add?id=52459756126507&quantity=1';
export function DynamicPricing() {
  return <section className="w-full" style={{
    background: 'var(--bg-dark)'
  }} aria-label="Oferta de precio" data-id="element-77">
      <div className="max-w-2xl mx-auto px-4 py-10 md:py-16" data-id="element-78">
        {/* Urgency header */}
        <div className="text-center mb-8" data-id="element-79">
          <span className="inline-block px-4 py-1.5 rounded-full text-xs font-bold mb-4 uppercase" style={{
          background: 'var(--color-gold)',
          color: 'white',
          fontFamily: 'var(--font-body)',
          letterSpacing: '0.15em'
        }} data-id="element-80">
            ⏰ OFERTA SOLO POR HOY
          </span>
          <h2 className="text-2xl md:text-3xl text-white mb-2" style={{
          fontFamily: 'var(--font-heading)',
          fontWeight: 600,
          letterSpacing: '-0.02em'
        }} data-id="element-81">
            Accedé al Sistema 10x2™
          </h2>
          <p className="text-sm mb-5" style={{
          fontFamily: 'var(--font-body)',
          color: 'rgba(255,255,255,0.5)'
        }} data-id="element-82">
            con todos los bonos incluidos — por un pago único
          </p>
          <CountdownTimer data-id="element-83" />
          <p className="text-xs mt-4" style={{
          fontFamily: 'var(--font-body)',
          color: 'rgba(255,255,255,0.35)'
        }} data-id="element-84">
            Me reservo el derecho de cerrar esta oferta sin aviso previo.
          </p>
        </div>

        {/* Main offer card — mockup only */}
        <div className="rounded-2xl overflow-hidden mb-5" style={{
        background: 'linear-gradient(135deg, #1A1714 0%, #2A2520 100%)',
        boxShadow: 'var(--shadow-xl)'
      }} data-id="element-85">
          <div className="w-full flex items-center justify-center py-8" data-id="element-86">
            <div className="text-center" data-id="element-87">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full mb-4" style={{
              background: 'var(--color-gold)',
              border: '2px solid rgba(255,255,255,0.2)'
            }} data-id="element-88">
                <div className="text-center" data-id="element-89">
                  <p className="text-white text-xs font-bold m-0" style={{
                  fontFamily: 'var(--font-body)',
                  letterSpacing: '0.05em'
                }} data-id="element-90">
                    OFF
                  </p>
                  <p className="text-white text-xl font-bold m-0 leading-none" style={{
                  fontFamily: 'var(--font-heading)'
                }} data-id="element-91">
                    67%
                  </p>
                </div>
              </div>
              <div className="inline-block px-5 py-2.5 rounded-xl" style={{
              background: 'rgba(255,255,255,0.06)',
              border: '1px solid rgba(255,255,255,0.10)'
            }} data-id="element-92">
                <p className="text-white font-bold text-base m-0" style={{
                fontFamily: 'var(--font-heading)',
                letterSpacing: '-0.01em'
              }} data-id="element-93">
                  Sistema 10x2™
                </p>
                <p className="text-xs m-0 mt-0.5" style={{
                fontFamily: 'var(--font-body)',
                color: 'rgba(255,255,255,0.45)'
              }} data-id="element-94">
                  + 4 Bonos Exclusivos
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Price card — clean, standalone */}
        <div className="rounded-2xl p-7 text-center mb-5" style={{
        background: 'var(--bg-surface)',
        border: '1px solid var(--border-default)',
        boxShadow: 'var(--shadow-sm)'
      }} data-id="element-95">
          <p className="eyebrow mb-4" data-id="element-96">Precio de oferta:</p>
          <p className="text-2xl line-through mb-1" style={{
          fontFamily: 'var(--font-body)',
          color: 'var(--text-muted)'
        }} data-id="element-97">
            $87.995 ARS
          </p>
          <p className="text-5xl font-bold mb-4" style={{
          fontFamily: 'var(--font-heading)',
          color: 'var(--color-primary)',
          lineHeight: 1.1,
          letterSpacing: '-0.02em'
        }} data-id="element-98">
            $19.999 ARS
          </p>
          <p className="text-sm m-0" style={{
          fontFamily: 'var(--font-body)',
          color: 'var(--text-muted)'
        }} data-id="element-99">
            Pago único · Sin suscripciones · Sin cargos ocultos
          </p>
        </div>

        {/* CTA — outside the card */}
        <a href={CART_URL} className="btn-cta-gold btn-cta-gold-pulse w-full text-base md:text-lg px-6 py-4 rounded-xl mb-2 block text-center" data-id="element-100">
          AGREGAR AL CARRITO &gt;&gt;
        </a>
        <p className="text-sm text-center mb-6" style={{
        fontFamily: 'var(--font-body)',
        color: 'var(--color-accent)'
      }} data-id="element-101">
          ✓ Descarga inmediata de todo el paquete
        </p>

        {/* Trust badges */}
        <div className="flex flex-wrap items-center justify-center gap-2 mb-6" data-id="element-102">
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium" style={{
          background: 'rgba(255,255,255,0.06)',
          color: 'rgba(255,255,255,0.7)',
          border: '1px solid rgba(255,255,255,0.10)',
          fontFamily: 'var(--font-body)'
        }} data-id="element-103">
            <LockIcon className="w-3.5 h-3.5" data-id="element-104" />
            Pago Seguro
          </span>
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium" style={{
          background: 'rgba(255,255,255,0.06)',
          color: 'rgba(255,255,255,0.7)',
          border: '1px solid rgba(255,255,255,0.10)',
          fontFamily: 'var(--font-body)'
        }} data-id="element-105">
            <ZapIcon className="w-3.5 h-3.5" data-id="element-106" />
            Acceso Inmediato
          </span>
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium" style={{
          background: 'rgba(255,255,255,0.06)',
          color: 'rgba(255,255,255,0.7)',
          border: '1px solid rgba(255,255,255,0.10)',
          fontFamily: 'var(--font-body)'
        }} data-id="element-107">
            <ShieldCheckIcon className="w-3.5 h-3.5" data-id="element-108" />
            Garantía 7 días
          </span>
        </div>

        {/* Guarantee */}
        <div className="rounded-2xl p-6 flex flex-col items-center text-center gap-4" style={{
        background: 'rgba(255,255,255,0.04)',
        border: '1px solid rgba(255,255,255,0.08)'
      }} data-id="element-109">
          {/* Seal image placeholder — circular */}
          <div className="w-20 h-20 rounded-full flex items-center justify-center flex-shrink-0 overflow-hidden" style={{
          background: 'rgba(184,146,42,0.12)',
          border: '1.5px solid rgba(184,146,42,0.4)'
        }} aria-label="Sello de garantía" data-id="element-110">
            <p className="text-xs text-center leading-tight m-0 px-2" style={{
            fontFamily: 'var(--font-body)',
            color: 'rgba(184,146,42,0.7)'
          }} data-id="element-111">
              📸
              <br data-id="element-112" />
              Sello
            </p>
          </div>
          <div data-id="element-113">
            <p className="font-bold text-base mb-1 text-white" style={{
            fontFamily: 'var(--font-heading)',
            letterSpacing: '-0.01em'
          }} data-id="element-114">
              Garantía "Amalo o Dejalo"
            </p>
            <p className="font-bold text-sm mb-2" style={{
            fontFamily: 'var(--font-heading)',
            color: '#C9A84C'
          }} data-id="element-115">
              7 Días — 100% Devolución
            </p>
            <p className="text-sm leading-relaxed m-0" style={{
            fontFamily: 'var(--font-body)',
            color: 'rgba(255,255,255,0.6)'
          }} data-id="element-116">
              <em data-id="element-117">
                Probalo durante 7 días completos. Si no es el sistema de comidas
                más práctico que usaste en tu vida, te devuelvo cada centavo.
              </em>{' '}
              <strong className="text-white" data-id="element-118">
                Sin preguntas. Sin letra chica. Sin vueltas.
              </strong>
            </p>
          </div>
        </div>
      </div>
    </section>;
}